(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    

	$('.collections').slick({
		arrows         : true,
		dots           : false,
		adaptiveHeight : true,
		prevArrow		: '<button type="button" class="slick-prev black">&lt;</button>',
		nextArrow		: '<button type="button" class="slick-next black">&gt;</button>',
		slidesToShow: 3,
		slidesToScroll: 1,

		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 590,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
		
	});
	
	$(window).on('resize orientationchange', function() {
		//console.log('why - reslick dat');
		$('.collections').slick('resize');
	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["details"] && !Shopify.designMode) return;
  try {
    

	$('.details').slick({
		arrows			: true,
		dots			: false,
		adaptiveHeight	: true,
		prevArrow		: '<button type="button" class="slick-prev">&lt;</button>',
		nextArrow		: '<button type="button" class="slick-next">&gt;</button>',
		autoplay		: false
	});
	
	$(window).on('resize orientationchange', function() {
		//console.log('details - reslick dat');
		$('.details').slick('resize');
	});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-slider"] && !Shopify.designMode) return;
  try {
    
    
	$('.collection-slider .collection-slider-wrapper').slick({
		arrows         : true,
		dots           : false,
		adaptiveHeight : true,
		prevArrow		: '<button type="button" class="slick-prev black">&lt;</button>',
		nextArrow		: '<button type="button" class="slick-next black">&gt;</button>',
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 590,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
		
	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-2025"] && !Shopify.designMode) return;
  try {
    
  if ($('.image-banner-slider')) {
    $('.image-banner-slider').slick({
      arrows         : false,
      dots           : false,
      adaptiveHeight : true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  } catch(e) { console.error(e); }
})();
})();
